
const Loader = ({ fullScreen }) => {
  return (
    <div className={`flex ${fullScreen === true ? 'h-screen' : 'h-full'} items-center justify-center`}>
      <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-t-transparent"></div>
    </div>
  );
};

export default Loader;

// import { useTheme } from "../../components/Theme/Themecontext";
// import { useEffect, useState } from "react";

// const Loader = ({ fullScreen }) => {
//   const { styles } = useTheme();
//   const { interior } = styles;
//   const [activeHexagons, setActiveHexagons] = useState([]);
//   const totalHexagons = 7;
  
//   // Positions adjusted to match the exact pattern in the image
//   // The pattern has 2 hexagons on top, 3 in the middle, and 2 at the bottom
//   const positions = [
//     { top: "0%", left: "25%" },     // top left
//     { top: "0%", left: "57.5%" },   // top right
//     { top: "25%", left: "10%" },    // middle left
//     { top: "25%", left: "42.5%" },  // middle center
//     { top: "25%", left: "75%" },    // middle right
//     { top: "50%", left: "25%" },    // bottom left
//     { top: "50%", left: "57.5%" },  // bottom right
//   ];
  
//   useEffect(() => {
//     let interval;
//     let isAppearing = true;
//     let currentIndex = 0;
    
//     const animateHexagons = () => {
//       if (isAppearing) {
//         // Adding hexagons one by one
//         setActiveHexagons(prev => [...prev, currentIndex]);
//         currentIndex++;
        
//         if (currentIndex >= totalHexagons) {
//           isAppearing = false;
//           setTimeout(() => {
//             currentIndex = 0;
//             animateHexagons();
//           }, 800); // Pause when all hexagons are visible
//           return;
//         }
//       } else {
//         // Removing hexagons one by one
//         setActiveHexagons(prev => 
//           prev.filter((_, idx) => idx !== currentIndex)
//         );
//         currentIndex++;
        
//         if (currentIndex >= totalHexagons) {
//           isAppearing = true;
//           currentIndex = 0;
//           setTimeout(() => {
//             setActiveHexagons([]);
//             animateHexagons();
//           }, 800); // Pause when all hexagons are gone
//           return;
//         }
//       }
      
//       interval = setTimeout(animateHexagons, 300);
//     };
    
//     // Start animation
//     interval = setTimeout(animateHexagons, 300);
    
//     return () => clearTimeout(interval);
//   }, []);
  
//   return (
//     <div
//       className={`flex ${
//         fullScreen === true ? "h-screen" : "h-full"
//       } items-center justify-center`}
//     >
//       <div className="relative w-48 h-36 mx-auto">
//         {positions.map((pos, i) => (
//           <div
//             key={i}
//             className={`absolute w-14 h-14 transition-opacity duration-300 ${
//               activeHexagons.includes(i) ? "opacity-100" : "opacity-0"
//             }`}
//             style={{
//               top: pos.top,
//               left: pos.left,
//             }}
//           >
//             <div 
//               className="w-full h-full"
//               style={{
//                 ...interior,
//                 clipPath: "polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
//                 backgroundColor: interior?.backgroundColor || "white"
//               }}
//             ></div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Loader;